import React from 'react';
import { Icon } from 'antd';

const optionsDefault = {
  okText: 'Готово',
  icon: <Icon type="check-circle" theme="filled" />,
  closable: false,
  maskClosable: true,
  centered: true,
  className: 'employee-success-form',
  onOk() {},
  onCancel() {},
};

export const successCompanyUpdation = data => ({
  ...optionsDefault,
  title: 'Данные Вашей компании успешно изменены!',
  content: `Данные компании ${data} успешно изменены.`,
});

export const successAdminUpdation = () => ({
  ...optionsDefault,
  title: 'Данные Вашего профиля успешно изменены!'
});
